import React from 'react';

export const DraftOrderPopupIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="52.461"
            height="60.829"
            viewBox="0 0 52.461 60.829"
        >
            <g
                id="Icon_feather-file-minus"
                data-name="Icon feather-file-minus"
                transform="translate(-2.539 1.201)"
            >
                <path
                    id="Path_1383"
                    data-name="Path 1383"
                    d="M29.565,3H10.713A4.713,4.713,0,0,0,6,7.713v37.7a4.713,4.713,0,0,0,4.713,4.713H38.992A4.713,4.713,0,0,0,43.7,45.418V17.139Z"
                    fill="none"
                    stroke="#179474"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="3"
                />
                <path
                    id="Path_1388"
                    data-name="Path 1388"
                    d="M33.267,3H11.453A5.453,5.453,0,0,0,6,8.453V52.08a5.453,5.453,0,0,0,5.453,5.453h32.72a5.453,5.453,0,0,0,5.453-5.453V19.36Z"
                    transform="translate(-2.961 -3.701)"
                    fill="none"
                    stroke="#179474"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                    strokeDasharray="2"
                />
                <path
                    id="Path_1384"
                    data-name="Path 1384"
                    d="M21,3V17.139H35.139"
                    transform="translate(8.565)"
                    fill="none"
                    stroke="#179474"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="3"
                />
            </g>
            <circle
                id="Ellipse_110"
                data-name="Ellipse 110"
                cx="14.5"
                cy="14.5"
                r="14.5"
                transform="translate(23.461 31.829)"
                fill="#fff"
            />
            <g
                id="Icon_feather-clock"
                data-name="Icon feather-clock"
                transform="translate(25.313 33.914)"
            >
                <path
                    id="Path_1386"
                    data-name="Path 1386"
                    d="M21.853,12.426A9.426,9.426,0,1,1,12.426,3,9.426,9.426,0,0,1,21.853,12.426Z"
                    fill="none"
                    stroke="#179474"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="3"
                />
                <path
                    id="Path_1387"
                    data-name="Path 1387"
                    d="M18,9v5.656l3.771,1.885"
                    transform="translate(-5.574 -2.229)"
                    fill="none"
                    stroke="#179474"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="3"
                />
            </g>
        </svg>
    );
};
